import { TextSkeleton } from 'common/TextSkeleton'
import { theme } from 'lib/theme'
import { Post } from 'models/Post'
import { Text } from 'primitives/Text'

interface PostCaptionProps {
  post: Post
  blurredText?: boolean
}

export const PostCaption = ({ blurredText = false, post }: PostCaptionProps) =>
  blurredText ? (
    <>
      <TextSkeleton
        css={{ margin: '12px 16px 4px 16px', width: 'calc(100% - 32px)' }}
      />
      <TextSkeleton css={{ margin: '4px 16px', width: 'calc(100% - 32px)' }} />
      <TextSkeleton
        css={{ margin: '4px 16px 16px 16px', width: 'calc(85% - 32px)' }}
      />
    </>
  ) : (
    <Text
      type='body3'
      css={{
        padding: '16px',
        color: theme.colors.gray800,
      }}
    >
      {post.description}
    </Text>
  )
